export default "__VITE_ASSET__D6F0v3UK__"